module.exports = __webpack_public_path__ + "static/shaw-logo-137d17db92f6917312ba0a997bcc13f7.jpeg";